import Swiper from 'swiper';
import { Navigation, Autoplay } from 'swiper/modules';

export default function slideshow(swiperOpts = {}, extraOpts = {}) {

  const defaults = {
    modules: [Navigation, Autoplay],
    spaceBetween: 10,
    navigation: {
      nextEl: this.$refs.next,
      prevEl: this.$refs.prev,
    },
  };

  const options = {...defaults, ...swiperOpts};

  return {
    swiper: null,
    options: null,
    currentIndex: 0,
    paginationLabels: [],
    prefersReducedMotion: false,
    navFixed: false,

    init() {
      if (!this.$refs.swiper) return;

      this.initOrDestroy();

      window.addEventListener('resize', () => {
        this.initOrDestroy();
      });
    },

    initOrDestroy() {
      if(!extraOpts.desktopOnly || (screen.width >= 1024 && !this.swiper)) {
        this.swiper = new Swiper(this.$refs.swiper, options);
        this.swiper.autoplay.stop();

        this.swiper.on('autoplayTimeLeft', (s, time, progress) => {
          this.$refs.pagination.style.setProperty("--progress", 1 - progress);
        });
        this.swiper.on('realIndexChange', s => {
          this.currentIndex = s.realIndex;
        });

        this.$watch('prefersReducedMotion', reduceMotion => {
          if(reduceMotion) {
            this.swiper.autoplay.stop();
            return;
          }
          this.swiper.autoplay.start();
        });

        let _prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
        if (_prefersReducedMotion instanceof MediaQueryList) {
          const _mediaQueryListener = (event) => {
            this.prefersReducedMotion = event.matches;
          };

          _prefersReducedMotion.addEventListener('change', _mediaQueryListener);
          this.prefersReducedMotion = _prefersReducedMotion.matches;
        }
      }
      else if(screen.width < 1024 && this.swiper) {
        this.swiper.destroy();
      }
    }
  };

}
